import { Component, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-bussness-transaction',
  templateUrl: './bussness-transaction.component.html',
  styleUrls: ['./bussness-transaction.component.css'],
  standalone: false
})
export class BussnessTransactionComponent implements OnInit {
  bDescription: any;
  accountNumber: any;


  constructor(private userService: PayService, private routerActivate: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.routerActivate.params.subscribe(params => {
      this.bDescription = params['name'];
      this.accountNumber = params['id']
    });
    localStorage.setItem("bDescription", this.bDescription);
  }

}
